import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  SEARCHBIOGRAPHY: {
    path: `${baseRoutes.userBaseRoutes}search-biography`,
  },
};

export default accessRoute;
